import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsSmartComponent } from 'app/documents/documents-smart/documents-smart.component';
import { DocumentsComponent } from 'app/documents/documents/documents.component';
import { AppPreviewDialogComponent } from './app-preview-dialog/app-preview-dialog.component';
import { DocumentDeleteDialogComponent } from './document-delete-dialog/document-delete-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertModule } from 'app/components/alert/alert.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentUploadDialogComponent } from './document-upload-dialog/document-upload-dialog.component';
import { MatListModule } from '@angular/material/list';
import { TruncateModule } from 'app/pipes/truncate/truncate-pipe.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DocumentCategoryComponent } from './document-category/document-category.component';

@NgModule({
    declarations: [
        DocumentCategoryComponent,
        DocumentsSmartComponent,
        DocumentsComponent,
        AppPreviewDialogComponent,
        DocumentDeleteDialogComponent,
        DocumentUploadDialogComponent
    ],
    imports: [
        AlertModule,
        CommonModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatCheckboxModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatGridListModule,
        MatTooltipModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        FormsModule,
        ReactiveFormsModule,
        MatMenuModule,
        MatListModule,
        TruncateModule,
        MatDividerModule,
        MatTooltipModule,
        MatIconModule
    ],
    exports: [
        DocumentsSmartComponent
    ]
})
export class BorrowerDocumentsModule { }
